import React, {useEffect, useState} from 'react';
import { Typography, Card, Button, Select, Input, Modal, Radio, Row, Col, Space } from "antd";
import dayjs from "dayjs";
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import {csTypeList} from "../../shared/utils/enum";
import {internalApi} from "../../common/axios";
import {stateList} from "../../shared/utils/defaultData";
import toast from "react-hot-toast";

const { Option } = Select;
dayjs.extend(utc);
dayjs.extend(timezone);

const CsEditModal = ({record}) => {
    const [rows, setRows] = useState(record);
    const [emailModalOpen, setEmailModalOpen] = useState(false);
    const [emailTitle, setEmailTitle] = useState('');
    const [emailContent, setEmailContent] = useState('');
    const [isSending, setIsSending] = useState(false);
    const [template, setTemplate] = useState([]);
    const [currentTemplate, setCurrentTemplate] = useState({});
    const [translatedContent, setTranslatedContent] = useState('');
    const [displayContent, setDisplayContent] = useState(record.request);
    const [isTranslated, setIsTranslated] = useState(false);

    const fetchMacro = async () => {
        const result = await internalApi.get('/css/macro');
        setTemplate(result.data.rows);
    };

    useEffect(() => {
        fetchMacro();
    }, [record]);

    const handleSetCurrentTemplate = (value) => {
        setCurrentTemplate(value);
        setEmailTitle('');
        setEmailContent('')
    };

    const handleSetTemplateContent = (value) => {
        const template = JSON.parse(value);
        setEmailTitle(template.title);
        setEmailContent(template.content);
    };

    const handleCopy = async (value) => {
        if (navigator.clipboard) {
            try {
                await navigator.clipboard.writeText(value);
                toast.success(`[${value}] 값이 복사되었습니다.`);
            } catch (error) {
                console.error('복사 실패:', error);
            }
        } else {
            const textarea = document.createElement('textarea');
            textarea.value = value;
            document.body.appendChild(textarea);
            textarea.select();
            document.execCommand('copy');
            document.body.removeChild(textarea);
            toast.success(`[${value}] 값이 복사되었습니다.`);
        }
    };

    const handleAnswer = () => {
        setEmailModalOpen(true);
    };

    const handleSendEmail = async () => {
        setIsSending(true);
        const result = await internalApi.post('/css/sendEmail', {
            email: rows.email,
            title: emailTitle,
            content: emailContent,
            csn: rows.csn,
        });
        toast.success(result.data.message);
        if (result.status === 200) {
            setEmailModalOpen(false);
            setEmailTitle('');
            setEmailContent('');
            setIsSending(false);
            setRows((prev) => ({ ...prev, state: 1 }));
        }
    };

    const handleChangeState = (value) => {
        if (value === rows.state) return;
        setRows((prevState) => ({
            ...prevState,
            state: value
        }));
        internalApi.post('/cs', {
            csn: rows.csn,
            state: value
        }).then((result) => {
            toast(result.data.message);
        }).catch(() => {
            setRows((prevState) => ({
                ...prevState,
                state: rows.state
            }));
        });
    };

    const handleTranslate = async () => {
        if (isTranslated) {
            setDisplayContent(rows.request);
            setIsTranslated(false);
        } else {
            if (translatedContent === '') {
                const res = await internalApi.get(`/css/translate?text=${rows.request}`);
                const {translation} = res.data.result;
                setDisplayContent(translation);
                setTranslatedContent(translation);
            } else {
                setDisplayContent(translatedContent);
            }
            setIsTranslated(true);
        }
    };

    return (
        <div className="cs-edit-modal-main">
            <Card className="title-paper" bordered={false} style={{ marginBottom: 16 }}>
                <Typography.Title level={5} className="cs-title">보낸 사람: {rows.email}</Typography.Title>
                <Typography.Title level={5} className="cs-title">문의 유형: {csTypeList[rows.type].desc}</Typography.Title>
            </Card>
            <Card className="param-grid" bordered={false} style={{ marginBottom: 16 }}>
                <Row gutter={16}>
                    <Col span={12}><Typography.Text className="cs-body">Game: Kitty</Typography.Text></Col>
                    <Col span={12}><Typography.Text className="cs-body" onClick={() => handleCopy(dayjs.unix(rows.requested).format('YYYY-MM-DD HH:mm:ss'))}>Receive: {dayjs.unix(rows.requested).format('YYYY-MM-DD HH:mm:ss')}</Typography.Text></Col>
                    <Col span={12}><Typography.Text className="cs-body" onClick={() => handleCopy(rows.device)}>Device: {rows.device}</Typography.Text></Col>
                    <Col span={12}><Typography.Text className="cs-body" onClick={() => handleCopy(rows.region)}>Country: {rows.region}</Typography.Text></Col>
                    <Col span={12}><Typography.Text className="cs-body" onClick={() => handleCopy(rows.os)}>OS: {rows.os}</Typography.Text></Col>
                    <Col span={12}><Typography.Text className="cs-body" onClick={() => handleCopy(rows.pid)}>PID: {rows.pid}</Typography.Text></Col>
                    <Col span={12}><Typography.Text className="cs-body" onClick={() => handleCopy(rows.userKey)}>UserKey: {rows.userKey}</Typography.Text></Col>
                    <Col span={12}><Typography.Text className="cs-body" onClick={() => handleCopy(rows.name)}>Name: {rows.name}</Typography.Text></Col>
                    <Col span={12}><Typography.Text className="cs-body" onClick={() => handleCopy(rows.version)}>Version: {rows.version}</Typography.Text></Col>
                    <Col span={12}><Typography.Text className="cs-body" onClick={() => handleCopy(rows.region)}>Region: {rows.region}</Typography.Text></Col>
                    <Col span={12}><Typography.Text className="cs-body" onClick={() => handleCopy(rows.email)}>Mail: {rows.email}</Typography.Text></Col>
                    <Col span={12}>
                        <Select
                            value={rows.state}
                            onChange={handleChangeState}
                            style={{ width: 200 }}
                            size="small"
                        >
                            {stateList.map((state) => (
                                <Option key={state.value} value={state.value} style={{color: state.color}}>
                                    {state.text}
                                </Option>
                            ))}
                        </Select>
                    </Col>
                </Row>
            </Card>
            <Card className="title-paper" bordered={false} style={{ marginBottom: 16 }}>
                <Typography.Title level={6}>문의 내용</Typography.Title>
                <Button onClick={handleTranslate} style={{marginBottom: '10px'}}>
                    {isTranslated ? '원문 보기' : '번역 보기'}
                </Button>
                <Typography.Text>{displayContent}</Typography.Text>
            </Card>
            <Button type="primary" onClick={handleAnswer} style={{ marginBottom: 16 }}>
                답변하기
            </Button>
            <Modal
                open={emailModalOpen}
                onCancel={() => setEmailModalOpen(false)}
                title="이메일 보내기"
                footer={null}
                width={700}
            >
                <Space direction="vertical" style={{ width: '100%' }}>
                    <Select
                        placeholder="[템플릿]라벨 선택"
                        onChange={handleSetCurrentTemplate}
                        style={{ width: '60%' }}
                        value={Object.keys(currentTemplate).length > 0 ? currentTemplate : undefined}
                    >
                        {template.map((option) => (
                            <Option key={option.label} value={option.value}>
                                {option.label}
                            </Option>
                        ))}
                    </Select>
                    <Radio.Group
                        name="type"
                        onChange={e => handleSetTemplateContent(e.target.value)}
                        style={{ marginBottom: 8 }}
                    >
                        {Object.keys(currentTemplate).map((key) => (
                            <Radio.Button key={key} value={JSON.stringify(currentTemplate[key])}>{key}</Radio.Button>
                        ))}
                    </Radio.Group>
                    <div style={{marginTop: 20}}>받는 사람: {rows.email}</div>
                    <Input
                        placeholder="Title"
                        value={emailTitle}
                        onChange={e => setEmailTitle(e.target.value)}
                    />
                    <Input.TextArea
                        placeholder="Content"
                        value={emailContent}
                        onChange={e => setEmailContent(e.target.value)}
                        autoSize={{ minRows: 10, maxRows: 25 }}
                    />
                    <Row justify="end" gutter={8} style={{ marginTop: 16 }}>
                        <Col>
                            <Button onClick={() => setEmailModalOpen(false)} disabled={isSending}>취소</Button>
                        </Col>
                        <Col>
                            <Button type="primary" onClick={handleSendEmail} loading={isSending}>보내기</Button>
                        </Col>
                    </Row>
                </Space>
            </Modal>
        </div>
    );
}

export default CsEditModal;
